<div class="container-main">
  <div class="item-div">
    <div class="class-div">
      <img src="../../assets/images/payment-fail.png" class="circular-image" />
    </div>
    <p class="txt-color">Payment Failed</p>
  </div>
</div>
